import { ReferralService } from '../services'

export const updateMyReferral = (referralDoc, myUid, myEmail) => {
    ReferralService.Referral
        .doc(`referral-${myUid}`)
        .set({
            authorId: myUid,
            authorEmail: myEmail,
            fromReferral: referralDoc,
            to: []
        })
        .catch((e) => console.log(e, 'usecase error'))
}